"use strict";
/**
 * Декларативная конфигурация файловых слотов для entity.
 *
 * Слот — именованная корзина файлов у сущности (avatar, attachments, contract).
 * Конфигурация задаётся при вызове `defineEntityFiles()` и определяет
 * лимиты, MIME-типы, режим удаления, версионирование и access control.
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=file-slot.js.map